const AddToViewHistory = () => {
  return '';
};

export default AddToViewHistory;
